/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2019 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Button, Row, Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap'

import { CopyToClipboard } from 'react-copy-to-clipboard';

import Select from 'react-select'

import {AppContext} from '../../AppContext';

class EnrollUser extends React.Component
{
  usernameIsAvailable = true;
  emailAddressIsNotUsedBefore = true;
  usernameElement = null;
  emailElement = null;

  async checkAvailableUsernames(event)
  {
    var bodyData = {};
    bodyData.username = this.state.username;

    let result = await this.context.dbTwig.callRestAPI('icam', 'validateNewUsername', bodyData);
    switch (result.status)
    {
      case 'success':
        this.setState({usernameValid: true}, this.setButtonDisabled);
        break;

      case 'apiError':
        if (this.context.dbTwig.UsernameExists === result.errorCode)
        {
          this.setState(
          {
            usernameValid: false,
            usernameFB: 'That username is not available.  Please choose another.'
          });
          this.usernameElement.focus();
          break;
        }

        this.context.dbTwig.apiErrorHandler(result, 'Unable to validate new username.');
        break;

      default:
        this.context.dbTwig.apiErrorHandler(result, 'Unable to validate new username.');
        break;
    }
  }

  async checkEmailAddress(emailAddress)
  {
    var bodyData = {};
    bodyData.emailAddress = emailAddress;

    let result = await this.context.dbTwig.callRestAPI('icam', 'validateNewEmailAddress', bodyData);
    switch (result.status)
    {
      case 'success':
        this.setState({emailAddressValid: true}, this.setButtonDisabled);
        break;

      case 'apiError':
        if (this.context.dbTwig.EmailExists === result.errorCode)
        {
          this.setState(
          {
            emailAddressValid: false,
            emailAddressFB: 'This email has already been registered in the system.'
          });
          this.emailElement.focus();
          break;
        }

        this.context.dbTwig.apiErrorHandler(result, 'Unable to validate new email address.');
        break;

      default:
        this.context.dbTwig.apiErrorHandler(result, 'Unable to validate new email address.');
        break;
    }
  }

  componentDidMount()
  {
    this.setState({ timezone: this.context.userSession.sessionInfo.defaultTimezone });    
    if (this.props.tabIndex === this.props.tabId) this.usernameElement.focus();
  }
  
  componentDidUpdate()
  {
    if (this.props.tabIndex === this.props.tabId && this.state.username === '') this.usernameElement.focus();
  }
  
  constructor(props)
  {
    super();

    let timezoneArray = [];
    let timezones = window.timezone.tz.names();
    for (let x = 0; x < timezones.length; x++) timezoneArray[x] = {timezone: timezones[x]};

    this.state =
    {
      timezones: timezoneArray,
      defaultTimezone: {timezone: window.timezone.tz.guess()},
      emailAddress: '',
      emailAddressValid: undefined,
      emailAddressFB: null,
      firstName: '',
      firstNameValid: undefined,
      firstNameFB: null,
      middleName: '',
      lastName: '',
      lastNameValid: undefined,
      lastNameFB: null,
      username: '',
      usernameValid: undefined,
      usernameFB: null,
      buttonDisabled: true
    }

    this.enrollUser = this.enrollUser.bind(this);
    this.setEmailAddress = this.setEmailAddress.bind(this);
    this.requiredField = this.requiredField.bind(this);
    this.selectTZone = this.selectTZone.bind(this);
  }

  debouncedCheckAvailableUsernames = window.debounce(this.checkAvailableUsernames, 500);
  debouncedCheckEmailAddress = window.debounce(this.checkEmailAddress, 500);

  async enrollUser(event)
  {
    this.setState({buttonDisabled: true});
    event.preventDefault();

    var bodyData = {};
    bodyData.emailAddress = this.state.emailAddress;
    bodyData.firstName = this.state.firstName;
    bodyData.middleName = this.state.middleName;
    bodyData.lastName = this.state.lastName;
    bodyData.username = this.state.username;
    bodyData.defaultTimezone = this.state.defaultTimezone.timezone;

    let result = await this.context.dbTwig.callRestAPI('icam', 'createUserAccount', bodyData);
    if ('success' !== result.status)
    {
      this.setState({buttonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error enrolling new user');
    }

    var temporaryPassword = result.jsonData.temporaryPassword;

    bodyData = {};
    bodyData.userId = result.jsonData.userId;

    result = await this.context.dbTwig.callRestAPI('dgBunker', 'createUserAccount', bodyData);
    if ('success' !== result.status)
    {
      this.setState({buttonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error enrolling new user');
    }

    let jsx = (
      <div>
        A new password for {this.state.username} has been generated.
        <br /><br />
        <CopyToClipboard text={temporaryPassword} 
            onCopy={() => this.context.postNotification('info', 'Temporary password copied to paste buffer.')} >
          <span title='Click to copy...'>{temporaryPassword}</span>
        </CopyToClipboard>
        <br /><br />
        Click on the password to copy it to your paste buffer so that you can send it to {this.state.firstName}
      </div>);

    this.context.openAppModal('New user enrolled.', jsx);
  }

  render()
  {
    if (this.props.tabId !== this.props.tabIndex) return false;

    return (
      <div>
        <Row>
          <Col style={{paddingTop: "10px"}}>
            <h4>Use this form to enroll a new user.</h4>
          </Col>
        </Row>
        <FormGroup row>
          <Label for="username" sm="2">Username</Label>
          <Col sm="3">
            <Input type="text" id="username" placeholder="Assign a username" value={this.state.username}
              invalid={(undefined === this.state.usernameValid ? undefined : !this.state.usernameValid)} 
              valid={(undefined === this.state.usernameValid ? undefined : this.state.usernameValid)} 
              onChange={this.requiredField} innerRef={(ref) => this.usernameElement = ref}
              title="You can not use the user's email address..."
            />
            <FormFeedback valid={false}>{this.state.usernameFB}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="emailAddress" sm="2">Email Address</Label>
          <Col sm={3}>
            <Input type="text" id="emailAddress" placeholder="Enter the user's email address"
              value={this.state.emailAddress} onChange={this.setEmailAddress}
              invalid={(undefined === this.state.emailAddressValid ? undefined : !this.state.emailAddressValid)} 
              valid={(undefined === this.state.emailAddressValid ? undefined : this.state.emailAddressValid)} 
              innerRef={(ref) => this.emailElement = ref}
            />
            <FormFeedback valid={false}>{this.state.emailAddressFB}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="firstName" sm="2">First Name</Label>
          <Col sm="3">
            <Input type="text" id="firstName" placeholder="First name" value={this.state.firstName} onChange={this.requiredField}
              invalid={(undefined === this.state.firstNameValid ? undefined : !this.state.firstNameValid)} 
              valid={(undefined === this.state.firstNameValid ? undefined : this.state.firstNameValid)}
            />
            <FormFeedback valid={false}>{this.state.firstNameFB}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="middleName" sm="2">Middle Name/Initial</Label>
          <Col sm="3">
            <Input type="text" id="middleName" placeholder="Middle Name/Initial"
              value={this.state.middleName} onChange={(event) => {this.setState({middleName: event.target.value})}}
            />
            <FormFeedback id="middleNameFeedback" style={{display:'none'}} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="lastName" sm="2">Last Name</Label>
          <Col sm="3">
            <Input type="text" id="lastName" placeholder="Last name" value={this.state.lastName} onChange={this.requiredField}
              invalid={(undefined === this.state.lastNameValid ? undefined : !this.state.lastNameValid)} 
              valid={(undefined === this.state.lastNameValid ? undefined : this.state.lastNameValid)} 
              />
            <FormFeedback valid={false}>{this.state.lastNameFB}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
            <Label sm="2" for='defaultTimezone'>Default Timezone</Label>
            <Col sm='3'>
              <Select id='defaultTimezone' value={this.state.defaultTimezone} options={this.state.timezones} 
                getOptionLabel={option => option.timezone} getOptionValue={option => option.timezone}
                onChange={this.selectTZone} isClearable={false} />
            </Col>
          </FormGroup>
        <Row style={{paddingTop: "10px"}}>
          <Col sm={{ size: 2, offset: 2 }}>
            <Button onClick={this.enrollUser} disabled={this.state.buttonDisabled} color="primary">Enroll</Button>
          </Col>
        </Row>
      </div>
    )
  }

  requiredField(event)
  {
    let valid = this.state[event.target.id + 'Valid'];
    let feedback = null;

    if ('' === event.target.value)
    {
      valid = false;
      feedback = 'You must provide a value for this field.';
    }
    else
    {
      valid = true;
    }

    if ('username' === event.target.id && '' !== event.target.value && !window.usernameIsValid(event.target.value)) return;
    
    this.setState(
    {
      [event.target.id]: event.target.value, 
      [event.target.id + 'Valid']: valid,
      [event.target.id + 'FB']: feedback
    }, 
    this.setButtonDisabled);

    if ('username' === event.target.id) this.debouncedCheckAvailableUsernames();
  }
  
  selectTZone(selectedTZone, actionMetaD)
  {
    if (null === selectedTZone) return;
    this.setState({defaultTimezone: selectedTZone});
  }

  setButtonDisabled()
  {
    let disabled = (this.state.emailAddressValid && this.state.firstNameValid && this.state.lastNameValid && 
      this.state.usernameValid ? false : true)

    this.setState({buttonDisabled: disabled});
  }

  setEmailAddress(event)
  {
    let valid = this.state.emailAddressValid;
    let value = event.target.value.trim();

    let emailAddressFB = null;
    let atSign = value.indexOf('@');
    let dot = value.lastIndexOf('.');
    if ('' === value)
    {
      valid = false;
      emailAddressFB = 'You must provide your email address in order to create an account.';
    }

    if ('' !== value && -1 !==  atSign && -1 !== dot && dot > atSign && 
      dot !== (value.length - 1))
    {
      if (!window.emailRegEx.test(value))
      {
        valid = false;
        emailAddressFB = "That does not look like a valid email address";
      }
      else
      {
        this.debouncedCheckEmailAddress(value)
      }
    }      

    this.setState(
    {
      emailAddress: value, 
      emailAddressFB: emailAddressFB, 
      emailAddressValid: valid
    });
  }

}

EnrollUser.contextType = AppContext;

export default EnrollUser